import SecureArea from "./classes/SecureArea.js";
import Dropzone from '../../vendor/dropzone';

Dropzone.autoDiscover = false;

// TODO: permission map as constants

//run SecureArea
global.securearea = new SecureArea();



/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/securearea-next/index.js
 **/